import styles from "./PromoBadge.module.css";

export type PromoBadgeProps = {
  promoText: string;
  promoTheme: string;
  className?: string;
  promoCode?: string;
};

export function PromoBadge({
  className = "",
  promoText,
  promoTheme,
  promoCode,
}: PromoBadgeProps) {
  return (
    <div
      className={`${styles.promoBadge} ${className}`}
      data-palette={promoTheme}
    >
      <p className={styles.promoText}>
        {promoText} <span className={styles.promoCode}>{promoCode}</span>
      </p>
    </div>
  );
}

PromoBadge.displayName = "PromoBadge";
